<template>
  <stepper-content-card
    @skipStep="$emit('skipStep')"
    @changeStep="handleStepChange"
    :dataLoading="dataLoading"
    :step="5"
    :hideFooter="true"
    imgUrl="https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80"
  >
    <div slot="heading">Almost Done!</div>
    <div slot="subheading">Complete your Registration using Google</div>
    <div slot="body">
      <v-row no-gutters>
        <v-col cols="12" class="my-5">
          <v-btn @click="handleStepChange" large rounded depressed block>
            <v-avatar size="24" class="mr-3">
              <img src="@/assets/search.png" alt="Google Icon" />
            </v-avatar>
            COMPLETE NOW
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </stepper-content-card>
</template>

<script>
import StepperContentCard from "./StepperContentCard";
import { mapGetters } from "vuex";
import {
  createPermanentAccount,
  updateCurrentUserProfile,
} from "./../services/Auth";

export default {
  props: ["currentPerson", "dataLoading"],
  data() {
    return {
      name: "",
      workEmail: "",
      mobile: "",
      instagram: "",
    };
  },
  mounted() {},
  computed: {
    ...mapGetters(["currentUser"]),
  },
  methods: {
    async handleStepChange() {
      var { user } = await createPermanentAccount();
      updateCurrentUserProfile({
        displayName: user.providerData[0].displayName,
        photoURL: user.providerData[0].photoURL,
      }).then(() => {
        this.$emit("changeStep", {
          onboarded: true,
          email: this.currentUser.email,
          name: this.currentUser.displayName,
          profileImg: this.currentUser.photoURL
        });
      });
    },
  },
  components: {
    StepperContentCard,
  },
};
</script>